import { TEX } from '../config/constants.js';
import { t } from './textos.js';

/**
 * Aparência de cada linha do ranking (Figma, quadro 50). A ordem vem
 * pronta do servidor (`RN-RAN-*`): o tablet não calcula desempate.
 */
const PODIO = [
    {
        trofeu: TEX.TROFEU_OURO, texto: '#5b2103', numero: '#6c2001',
        fio: 0x792901, fioMeio: 0xd16601,
        degrade: [[0, 0xd16400], [0.351, 0xfdce03], [0.486, 0xfdef48], [0.622, 0xfdce03], [1, 0xd16400]]
    },
    {
        trofeu: TEX.TROFEU_PRATA, texto: '#28292b', numero: '#3f4754',
        fio: 0x434a57, fioMeio: 0x7a8290,
        degrade: [[0, 0x78808e], [0.351, 0xbdc2ce], [0.486, 0xe4eaf5], [0.622, 0xbdc2ce], [1, 0x78808e]]
    },
    {
        trofeu: TEX.TROFEU_BRONZE, texto: '#ebb583', numero: '#4c1a07',
        fio: 0x501c05, fioMeio: 0x863e17,
        degrade: [[0, 0x6b2b10], [0.351, 0x9f4d22], [0.486, 0xe29c52], [0.622, 0x9f4d22], [1, 0x6b2b10]]
    }
];

const COMUM = { trofeu: null, texto: '#1a1a1a', numero: '#ffffff', fio: 0x525252, fioMeio: 0xffffff, degrade: null };

/** @param {number} posicao 1 = primeiro lugar */
export function estiloDaPosicao (posicao) {
    return PODIO[posicao - 1] ?? COMUM;
}

export function formatarPontos (pontos) {
    return t(pontos === 1 ? 'ranking.ponto' : 'ranking.pontos', { pontos });
}
